import AboutHomePage from '../components/about.home-page';
import WaitingDocs from '../components/waiting-docs/waiting-docs';
import MissingReportedHoursHomePage from '../components/working-hours/missing-reported-hours.home-page';
import RatesTableHomePage from '../components/rates/rates-table.home-page';
import React, { useEffect, useState } from 'react';
import { getHomeDataOperation } from '../operation/get-home-data-operation';
import { HomeData } from '../../../api/types/home-data/home-data';
import globalConfigStore from '../../../stores/global-config-store';
import { TodayLecturesHomePage } from '../components/today-lectures.home-page';
import globalSettingsBranches from '../../../stores/global-settings-branches';
import { observer } from 'mobx-react-lite';
import UnfinishedLectures from '../components/unfinished-lectures/unfinished-lectures.home-page';

const HomeTab = observer(() => {
  const [data, setData] = useState<HomeData | null>(null);
  const [loading, setLoading] = useState(false);
  const fetchData = async () =>
    getHomeDataOperation(
      globalConfigStore.rootFilter.currentBranches?.id ??
        globalSettingsBranches.branches?.[0]?.id,
      setData,
      setLoading,
    );
  useEffect(() => {
    fetchData();
  }, [globalConfigStore.rootFilter.currentBranches]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '270px',
          alignItems: 'stretch',
        }}
      >
        <div style={{ flex: '0.2' }}>
          <AboutHomePage homeData={data} currentUser={globalConfigStore.user} />
        </div>

        <div style={{ width: '16px' }} />

        <div style={{ flex: '0.8' }}>
          <WaitingDocs onUpdate={fetchData} docs={data?.docs || []} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '270px',
          alignItems: 'stretch',
          marginTop: '16px',
        }}
      >
        <div style={{ flex: '0.55' }}>
          <MissingReportedHoursHomePage
            onUpdate={fetchData}
            pendingWorkingHours={data?.pendingWorkingHours || []}
          />
        </div>

        <div style={{ width: '16px' }} />

        <div style={{ flex: '0.45' }}>
          <TodayLecturesHomePage homeData={data} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '270px',
          alignItems: 'stretch',
          marginTop: '16px',
        }}
      >
        <div style={{ flex: '1' }}>
          <RatesTableHomePage rates={data?.rates || []} onRefresh={fetchData} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '270px',
          alignItems: 'stretch',
          marginTop: '16px',
        }}
      >
        <div style={{ flex: '1' }}>
          <UnfinishedLectures
            unfinishedLectures={data?.unfinishedLectures || []}
            onUpdate={fetchData}
          />
        </div>
      </div>
    </div>
  );
});

export default HomeTab;
